/* unplugin-vue-components disabled */import script from "./userName.vue?vue&type=script&lang=ts&setup=true"
export * from "./userName.vue?vue&type=script&lang=ts&setup=true"

export default script